export default function navigationPaths() {
  return {
    InvoicesForm: '/invoices/invoices-form',
    InvoicesPreview: '/invoices/invoices-preview',
    Invoices: '/invoices',
    CorrectionInvoicesPreview: '/invoices/correction-invoices-preview',
    //CostsInvoicesEdit: "/costs-invoices/edit",
    CostInvoicesForm: '/cost-invoices/cost-invoices-form',
    CostInvoicesFormPOC: '/cost-invoices/cost-invoices-form/poc',
    CostInvoicesFormEdit: '/cost-invoices/cost-invoices-form/:costId',
    CostInvoicesFormPreview: '/cost-invoices/cost-invoices-form/:costId/preview',
    CostInvoices: '/cost-invoices',
    Dashboard: '/dashboard',
    DashboardFluent: '/dashboard/fluent',
    ProformasForm: '/proformas/proformas-form',
    ProformasPreview: '/proformas/proformas-preview',
    Proformas: '/proformas',
    InventoryForm: '/inventory/inventory-form',
    Inventory: '/inventory',
    ContractorForm: '/contractors/contractors-form',
    Contractors: '/contractors',
    UserProfile: '/profile',
    Settings: '/settings',
    Exports: '/settings/exports',
    UserAccountSettings: '/settings/settings-account',
    UserUsersSettings: '/settings/settings-users',
    UserOrganizationSettings: '/settings',
    UserBankingSettings: '/settings/settings-banking',
    UserDocumentsAutosending: '/settings/settings-documentautosending',
    UserLayoutsSettings: '/settings/settings-layout',
    LogIn: '/logIn',
    Register: '/register',
    RegisterInvitation: '/register-invitation',
    RegisterConfirmation: '/register-confirmation',
    ForgotPassword: '/forgot-password',
    ResetPassword: '/reset-password',
    Home: '/',
    HomeAfterEmailConfirmation: '/?confirmed=true',
    CorrectionInvoicesForm: '/correction-invoices/correction-invoices-form',
    Pricing: '/settings-pricing',
    LinkedIn: '/linkedin',
    Autologin: '/autologin',
    ViewEditor: '/view-editor',
    Snake: '/snake',
  };
}

export function navigationPathsTranslations(path) {
  const translations = {
    'invoices-form': 'Nowa Faktura',
    'invoices-preview': 'Podgląd Faktury',
    invoices: 'Faktury',
    'proformas-form': 'Nowa Faktura Pro-Forma',
    proformas: 'Faktury Pro-Forma',
    'cost-invoices-form': 'Nowa Faktura kosztowa',
    'cost-invoices': 'Faktury kosztowe',
    'inventory-form': 'Nowy produkt',
    inventory: 'Produkty',
    'contractors-form': 'Nowy Kontrahent',
    contractors: 'Kontrahenci',
    profile: 'Profil',
    user: 'Użytkownik',
    settings: 'Ustawienia',
    'settings-account': 'Ustawienia konta',
    'settings-users': 'Użytkownicy',
    'settings-organization': 'Dane firmy',
    'settings-banking': 'Rachunki bankowe',
    'settings-documentautosending': 'Wysyłka dokumentów',
    'settings-layout': 'Prezentacja',
    register: 'Zarejestruj',
    logIn: 'Zaloguj',
    'correction-invoices-form': 'Nowa Faktura korygująca',
    'settings-pricing': 'Plany cenowe',
    dashboard: 'Panel główny',
  };

  return translations[path];
}
